module.exports = __webpack_public_path__ + "img/Icon_Copy.885a94cd.svg";